import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import AccessDenied from "../Pages/AccessDenied/AccessDenied";
import { withLaunchSearch } from "../utilities/appSessionKey";
import {
  canAccessAppPath,
  isAuthzAppAccessDenied,
  isAuthzAppType,
  isAuthzBootstrapPending,
  normalizeAuthzAppType,
  resolveAuthzFallbackPath,
  shouldUsePermissionUi,
} from "../utilities/authzPermissions";

/**
 * When UMS AuthZ is ready, block routes the user lacks permission for.
 * No UMS profile for this app → Access Denied (Keycloak Viewer is not enough).
 */
const AuthzAppGate = ({ appType, children, onLogout }) => {
  const location = useLocation();
  const authzState = useSelector((state) => state.authzState);
  const authzApp = normalizeAuthzAppType(appType);

  if (!authzApp || !isAuthzAppType(appType)) {
    return children;
  }

  if (isAuthzBootstrapPending(appType, authzState)) {
    return children;
  }

  if (isAuthzAppAccessDenied(appType, authzState)) {
    return <AccessDenied onLogout={onLogout} />;
  }

  if (!shouldUsePermissionUi(appType, authzState)) {
    return children;
  }

  const pathname = location.pathname || "";
  if (canAccessAppPath(authzApp, pathname, authzState)) {
    return children;
  }

  const fallback = resolveAuthzFallbackPath(authzApp, authzState.permissions);
  if (fallback && fallback !== pathname) {
    return <Redirect to={withLaunchSearch(fallback)} />;
  }

  return <AccessDenied onLogout={onLogout} />;
};

export default AuthzAppGate;
